import { ReadiedRoute, Redirect } from "@itandi/tools/next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/property_deals/[id]/Page";

export const PATH = (id: number): string => `/property_deals/${id}`;

function Home() {
	return (
		<ReadiedRoute fallback={<Redirect url="/" />}>
			<NskHead title="案件グループ" />
			<Component />
		</ReadiedRoute>
	);
}
export default Home;
